import { transparentize } from 'polished';
import styled from 'styled-components';
import { Colors } from '../../../ui';
import { CoolTableTheme, Table } from '../../../ui/Table';

export const TaskTableTheme = styled(CoolTableTheme)`
    cursor: default !important;

    --row-hover-bg: none;
    --row-active-bg: none;
    --row-selected-bg: ${transparentize(0.5, Colors.hover)} !important;
    --cell-padding: .25rem .5rem;

    tr {
        border-bottom: solid .0625rem ${Colors.border};

        td {
            white-space: nowrap;

            &:first-child {
                padding: .25rem .5rem;
            }
        }
    }

    ${Table.Head} {
        td {
            padding-top: .375rem;
            padding-bottom: .375rem;
        }
    }

    @media (min-width: 80rem) {
        --cell-padding: .25rem 1rem;
    }

    @media (min-width: 120rem) {
        --cell-padding: .25rem 1.5rem;
    }
`;
